import myFunctions from "../myFunctions";
import rests from "../_ApiConn/apiRests";



const getRestsUrls = async () => {
  
    let dFromF = await rests.getRestsUrls();
    let lstBack = dFromF.filter(item => item.restStatus != "לא מפורסם");

   

    return (lstBack);
}

//מושך מסעדה לפי איידי.
//
//השרת מחזיר null לעסק ב-restStatus חסום ("לא פעיל" / "לא מפורסם"),
//ולכן חייב להיות null-safe - קודם הייתה כאן גישה ל-dFromF.restStatus
//שהייתה קורסת על null.
//הבדיקה על "לא מפורסם" נשמרת כהגנה כפולה, למקרה של שרת לא מעודכן
const getRestByIdWitUnPublished = async (id) => {
    let dFromF = await rests.getRestById(id);
    if (!dFromF || dFromF.errMsg) return null;
    let lstBack = (dFromF.restStatus !== "לא מפורסם" && dFromF.restStatus !== "לא פעיל") ? dFromF : null;
    return (lstBack);
}


const getMainRestsByIds = async (idsList) => {
    let lstBack = await rests.getMainRestsByIds({ idsList });

    return (lstBack);
}


const getMainRests = async (cityId) => {
    let lstBack = await rests.getMainRests(cityId ? { cityId } : "");

    return (lstBack);
}

const getTableReservsList = async () => {
    let lstBack = await rests.getTableReservsList("");

    return (lstBack);
}

const getRestById = async (id) => {
    let dFromF = await rests.getRestById(id);
    let lstBack = (dFromF.restStatus != "לא מפורסם" && dFromF.restStatus != "לא פעיל") ? dFromF : null;
    return (lstBack);
}
const getRestNowOpen = async (obj) => {
    let dFromF = await rests.getRestNowOpen(obj);
    let lstBack = dFromF;
    return (lstBack);
}

const getSerchResault = async (txtSrch) => {
    let dFromF = await rests.getSerchResault(txtSrch);
    let lstBack = dFromF.filter(item => item.restStatus != "לא פעיל" && item.restStatus != "לא מפורסם");
    return (lstBack);
}



const getallBuisSmallLst = async (txtToSearch) => {
    let dFromF = await rests.getallBuisSmallLst(txtToSearch);
    
    return (dFromF);
}

const getSupermarketProducts = async (restId, startCategoryIndex, startSubCategoryIndex, offset, limit) => {
    let result = await rests.getSupermarketProducts(restId, startCategoryIndex, startSubCategoryIndex, offset, limit);
    return result;
}

const logSearchTerm = async (term) => {
    return await rests.logSearchTerm(term);
}

export default {
    getallBuisSmallLst,
    getMainRestsByIds,
    getMainRests,
    getRestNowOpen,
    getRestById,
    getSerchResault,
    getRestByIdWitUnPublished,
    getRestsUrls,
    getTableReservsList,
    getSupermarketProducts,
    logSearchTerm
};